import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { EsclusioneGrandiAcquirentiModel } from '@/models/tables/ms-discount-model';

@Component({
  selector: 'app-esclusione-grandi-acquirenti-renderer',
  template: `
    <span
      *ngIf="items && items.length > 0"
      [matTooltip]="tooltipText"
      matTooltipClass="esclusione-grandi-acquirenti-tooltip"
      matTooltipPosition="above"
      class="cursor-help"
    >
      {{ firstItemText }}
      <span *ngIf="remainingCount > 0" class="text-blue-400 ml-1">+{{ remainingCount }}</span>
    </span>
    <span *ngIf="!items || items.length === 0">-</span>
  `,
  styles: [
    `
      :host {
        display: inline-block;
      }
      .text-blue-400 {
        color: #60a5fa;
      }
      .ml-1 {
        margin-left: 0.25rem;
      }
      .cursor-help {
        cursor: help;
      }
    `,
  ],
})
export class EsclusioneGrandiAcquirentiRendererComponent implements OnInit, OnChanges {
  @Input() items: EsclusioneGrandiAcquirentiModel[];

  ngOnInit(): void {
    // Ensure items is initialized
    if (!this.items) {
      this.items = [];
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['items']) {
      // Ensure items is always an array
      if (!this.items || !Array.isArray(this.items)) {
        this.items = [];
      }
    }
  }

  get firstItemText(): string {
    if (!this.items || !Array.isArray(this.items) || this.items.length === 0) {
      return '';
    }
    const first = this.items[0];
    if (!first || !first.codiceGA || !first.descrizione) {
      return '';
    }
    return `${first.codiceGA} - ${first.descrizione}`;
  }

  get remainingCount(): number {
    if (!this.items || !Array.isArray(this.items) || this.items.length <= 1) {
      return 0;
    }
    return this.items.length - 1;
  }

  get tooltipText(): string {
    if (!this.items || !Array.isArray(this.items) || this.items.length === 0) {
      return '';
    }
    return this.items
      .filter((item) => item && item.codiceGA && item.descrizione)
      .map((item) => `• ${item.codiceGA} - ${item.descrizione}`)
      .join('\n');
  }
}
